import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Input — Flozy Design System
 *
 * Resting:  white bg, var(--border-strong) hairline, shadow-xs, 14/20 ink text.
 * Focus:    border-primary + 4px primary-tinted ring (var(--shadow-focus)).
 * Invalid:  destructive border + tinted ring (aria-invalid).
 * Disabled: 0.5 opacity, no pointer events.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // base
        "h-9 w-full min-w-0 rounded-md border bg-background text-sm leading-5",
        "px-3 py-2 text-foreground placeholder:text-muted-foreground",
        "border-[var(--border-strong)] shadow-xs outline-none",
        "transition-[color,border-color,box-shadow] duration-150",
        "selection:bg-primary/15 selection:text-foreground",
        // file inputs
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        // disabled
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "disabled:bg-muted disabled:text-muted-foreground",
        // focus
        "focus-visible:border-primary focus-visible:ring-[3px] focus-visible:ring-[color-mix(in_oklch,var(--primary)_22%,transparent)]",
        // invalid
        "aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        // dark
        "dark:bg-[var(--background)]",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
